'use client';

import { Skeleton, Space, Typography } from 'antd';
import React from 'react';

import { AppColors } from '../../theme';
import { styles } from './loading-screen.styles';

const { Text } = Typography;

/**
 * `LoadingScreen` es un componente funcional que muestra un indicador de carga.
 *
 * Este componente se utiliza para indicar que un proceso se está ejecutando en segundo plano,
 * como la obtención de datos o cualquier otra operación asíncrona. Consiste en un
 * nodo de esqueleto con el texto "TRAKY" dentro.
 *
 * @component
 *
 * @returns {React.ReactElement} El componente de pantalla de carga renderizado.
 *
 * @example
 * return (
 *   <LoadingScreen />
 * )
 */
const LoadingScreen = () => {
  return (
    <>
      <Space size='middle' style={styles.container} align='center'>
        <Skeleton.Node active style={{ width: 320 }}>
          <Text type='secondary' style={{ fontSize: 40, color: AppColors.VA.PRIMARY._50_ }}>
            TRAKY
          </Text>
        </Skeleton.Node>
      </Space>
    </>
  );
};

export default LoadingScreen;
